import { render, staticRenderFns } from "./index-new.vue?vue&type=template&id=2282b9c0&scoped=true"
import script from "./index-new.vue?vue&type=script&lang=js"
export * from "./index-new.vue?vue&type=script&lang=js"
import style0 from "./index-new.vue?vue&type=style&index=0&id=2282b9c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282b9c0",
  null
  
)

export default component.exports